import { getSubStepValues } from '#models/general/steps';
import {
  FIVE_NUMBERS_REGEX,
  FROM_0_TO_999_W1_DECIMAL_REGEX,
  NEGATIVES_W1_DECIMAL_REGEX
} from '#utils/string/regex';
import Checkbox from '#components/general/Checkbox';
import Input from '#components/general/Input';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';

import { WORT_ANALYSIS_FIELDS, MASH_SUBSTEPS_IDS } from './constants';

export const getWortAnalysisFields = ({ values, errors }) => {
  const getWortAnalysisValues = getSubStepValues(MASH_SUBSTEPS_IDS.WORT_ANALYSIS, values, errors);
  return [
    {
      key: 'dipAndLitresWort',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.WORT_DIP),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
          measure: MEASURE_TYPES.LENGTH,
          noMargin: true
        },
        {
          ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.WORT_LITRES),
          Component: Input,
          needsRegex: true,
          customRegex: FIVE_NUMBERS_REGEX,
          measure: MEASURE_TYPES.LITRES,
          noMargin: true
        }
      ]
    },
    {
      key: 'tempWortAndOriginalGravity',
      Component: AdelphiFieldsRow,
      fields: [
        {
          ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.WORT_TEMP),
          Component: Input,
          needsRegex: true,
          customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
          measure: MEASURE_TYPES.TEMPERATURE,
          noMargin: true
        },
        {
          ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.ORIGINAL_GRAVITY),
          Component: Input,
          needsRegex: true,
          customRegex: NEGATIVES_W1_DECIMAL_REGEX,
          noMargin: true
        }
      ]
    },
    {
      ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.MTE),
      Component: Input,
      noMargin: true
    },
    {
      ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.PSY),
      Component: Input,
      needsRegex: true,
      customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
      noMargin: true
    },
    {
      ...getWortAnalysisValues(WORT_ANALYSIS_FIELDS.WASHBACK_SEALED),
      Component: Checkbox,
      noMargin: true
    }
  ];
};
